import { type TOC } from '@ember/component/template-only';

interface Signature {
  Element: HTMLButtonElement;
  Blocks: { default: [] };
}

/**
 * On small screens, the button uses the font size of the FUI `tiny` button.
 * A FUI size bigger than `tiny` set by the caller keeps its own font size.
 */
const UiKitButtonComponent: TOC<Signature> = <template>
  <button
    type='button'
    class='ui button !uppercase max-sm:[&.ui.button:not(.small,.medium,.large,.big,.huge,.massive)]:text-[0.85714286rem]'
    ...attributes
  >
    {{yield}}
  </button>
</template>;
export default UiKitButtonComponent;
